import React from "react";

import { clientEventTracker } from "../../utils/clientTelemetry";
import { ErrorPage } from "./ErrorPage";

type ErrorProps = {
  identity?: string;
  tenantId?: string;
};

type ErrorState = {
  hasError: boolean;
  error?: Error;
};

export class ErrorBoundary extends React.Component<ErrorProps, ErrorState> {
  state = {
    hasError: false,
  };

  componentDidCatch(error: Error) {
    console.error(error);
    this.setState({
      hasError: true,
      error,
    });

    const userId = this.props.identity || "error_boundary_anonymous_user";
    const tenantId = this.props.tenantId || "unknown-tenant";

    clientEventTracker.trackFatalError(
      "error_boundary",
      { userId, tenantId },
      {
        href: window.location.href,
        errorMessage: error.message,
        errorStack: error.stack,
      }
    );
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    } else {
      return this.props.children;
    }
  }
}
